export const PLANET_CARD_TYPES = {
  ALPHA_BASE_LOADING: 'ALPHA_BASE_LOADING',
  ALPHA_BASE_ACTIVE: 'ALPHA_BASE_ACTIVE',
  ALPHA_BASE_COMPLETED: 'ALPHA_BASE_COMPLETED',
  ALPHA_BASE_DEPART: 'ALPHA_BASE_DEPART',
  ALPHA_BASE_ARRIVED: 'ALPHA_BASE_ARRIVED',
  RAID_LOADING: 'RAID_LOADING',
  RAID_NONE: 'RAID_NONE',
  RAID_NO_COMMAND_STRUCT: 'RAID_NO_COMMAND_STRUCT',
  RAID_STARTED: 'RAID_STARTED',
  RAID_ACTIVE: 'RAID_ACTIVE',
  RAID_RETREAT: 'RAID_RETREAT'
};